<template>
  <div>
    <v-card
      @click="onClickCard"
      :disabled="loading"
    >
      <div
        v-if="bulkDelFlg"
        class="checkbox-container-tight d-flex justify-left align-center mt-7"
      >
        <v-checkbox
          v-if="content.purchasedCount === 0"
          v-model="computedBulkDelTarget"
          :value="content.multimediaId"
          :disabled="loading"
          hide-details
          density="compact"
          class="tight-checkbox"
          color="primary"
          @click.stop
          style="--v-selection-control-size: 40px; font-size: 1.5rem;"
        />
        <v-checkbox
          v-else
          hide-details
          density="compact"
          class="tight-checkbox"
          style="visibility: hidden;"
        />
      </div>

      <v-img
        v-if="content.status === 'completed'"
        :src="content.thumbnailUrl || ''"
        sizes="180px"
        height="180px"
      />

      <div
        v-else-if="content.status === 'failed'"
        style="height: 180px"
        class="d-flex justify-center align-center"
      >
        <v-chip
          size="small"
          color="error"
          variant="flat"
          class="text-white"
        >
          失敗
        </v-chip>
      </div>

      <div
        v-else
        style="height: 180px"
        class="d-flex justify-center align-center"
      >
        <v-chip
          size="small"
          color="secondary"
          variant="flat"
          style="color: white !important;"
        >
          処理中
        </v-chip>
      </div>

      <v-card-text class="pa-0">
        <v-container>
          <v-row align="center">
            <v-col cols="12">
              <v-table density="compact">
                <tbody>
                  <tr>
                    <td>種類</td>
                    <td>
                      <v-chip
                        v-if="content.category === 'photo'"
                        size="small"
                        color="success"
                        variant="flat"
                      >
                        写真
                      </v-chip>

                      <v-chip
                        v-else
                        size="small"
                        color="purple"
                        variant="flat"
                      >
                        動画
                      </v-chip>
                    </td>
                  </tr>

                  <tr>
                    <td>撮影日</td>
                    <td>{{ formatDate(content.date) }}</td>
                  </tr>

                  <tr>
                    <td>単価</td>
                    <td>¥{{ content.price?.toLocaleString() }}</td>
                  </tr>

                  <tr>
                    <td>購入数</td>
                    <td>{{ content.purchasedCount }}</td>
                  </tr>

                  <tr>
                    <td>売上</td>
                    <td>{{ content.revenue }}</td>
                  </tr>

                  <tr>
                    <td>ファイル名</td>
                    <td style="word-break: break-all">
                      {{ content.filename }}
                    </td>
                  </tr>

                  <tr>
                    <td>シリアルNO</td>
                    <td>{{ content.serialNumber }}</td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import dayjs from "dayjs";
import { MultimediaResponse } from "chaild-api/lib";

export default defineComponent({
  name: "MemoruContentCard",

  props: {
    content: {
      type: Object as PropType<MultimediaResponse>,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    bulkDelFlg: {
      type: Boolean,
      default: false,
    },

    bulkDelTarget: {
      type: Array as PropType<(string | number)[]>,
      default: () => [],
    },
  },

  emits: [
    "click",
    "update:bulkDelTarget",
  ],

  setup(props, { emit }) {
    const computedBulkDelTarget = computed({
      get: () => props.bulkDelTarget,
      set: (value) => {
        emit("update:bulkDelTarget", value);
      },
    });

    const formatDate = (value: string): string => {
      if (!value) return "";
      return dayjs(value).format("YYYY/MM/DD");
    };

    const getMovieSizeText = (seconds: number): string => {
      if (!seconds) return "0:00";

      return `${Math.floor(seconds / 60)}:${Math.floor(
        seconds % 60
      )}`;
    };

    const onClickCard = () => {
      if (props.bulkDelFlg) {
        if (props.content.purchasedCount !== 0) return;

        const id = props.content.multimediaId;
        // 現在のチェック済みリストをコピー（リアクティブな状態を壊さないため）
        const currentTargets = [...computedBulkDelTarget.value];
        const index = currentTargets.indexOf(id);

        if (index > -1) {
          // すでにチェックされている場合は外す
          currentTargets.splice(index, 1);
        } else {
          // チェックされていない場合は追加する
          currentTargets.push(id);
        }

        // 算出プロパティのsetterを介して親コンポーネントへ通知
        computedBulkDelTarget.value = currentTargets;
        return;
      }

      emit("click");
    };

    return {
      computedBulkDelTarget,
      formatDate,
      getMovieSizeText,
      onClickCard,
    };
  },
});
</script>